import { Button, ButtonVariants } from "@inno-ui/button";
import { MultiplyIcon, PlusIcon } from "@inno-ui/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppForm } from "../../../hooks/use-form";
import { useAppointmentStore } from "../../../store/appointment/appointment-store";
import { useGeneralStore } from "../../../store/general/general-store";
import { AddGuestForm } from "../../desktop/screens/appointment-content/add-guest/add-guest-form/add-guest-form";
import { ADD_GUEST_FORM_FIELDS } from "../../desktop/screens/appointment-content/add-guest/add-guest-form/add-guest-form.constant";
import { addGuestFormSchema } from "../../desktop/screens/appointment-content/add-guest/add-guest-form/add-guest-form.schema";
import MobileFooter from "../mobile-footer/mobile-footer";
import styles from "./add-guest-mobile.module.scss";

export function AddGuestMobile() {
  const {
    addParticipant,
    currentSelectedParticipant,
    updateParticipant,
    resetCurrentSelectedParticipant,
  } = useAppointmentStore();
  const { hideAddGuestForm } = useGeneralStore();
  const { t } = useTranslation();

  const form = useAppForm({
    defaultValues: ADD_GUEST_FORM_FIELDS,
    onSubmit: ({ value }) => {
      if (currentSelectedParticipant?.length) {
        updateParticipant(currentSelectedParticipant[0]?.id, {
          firstName: value.firstName,
          lastName: value.lastName,
          email: value.email,
          phone: value.phone,
          gender: value.gender.value,
        });
      }
      else {
        addParticipant({
          id: Math.random().toString(),
          firstName: value.firstName,
          lastName: value.lastName,
          email: value.email,
          phone: value.phone,
          gender: value.gender.value,
        });
      }
      form.reset();
      hideAddGuestForm();
      resetCurrentSelectedParticipant();
    },
    validators: {
      onSubmit: addGuestFormSchema,
    },
  });

  useEffect(() => {
    if (currentSelectedParticipant?.length && form) {
      const participant = currentSelectedParticipant[0];
      form.setFieldValue("firstName", participant.firstName);
      form.setFieldValue("lastName", participant.lastName);
      form.setFieldValue("email", participant.email);
      form.setFieldValue("gender", {
        // capitalize the first letter of the gender
        label:
          participant.gender.charAt(0).toUpperCase()
          + participant.gender.slice(1),
        value: participant.gender,
      });
      // need this to ensure the phone field is set correctly
      const timer = setTimeout(() => {
        form.setFieldValue("phone", participant.phone);
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [currentSelectedParticipant, form]);

  return (
    <div className={styles.addGuestFormMobile}>
      {/* @ts-expect-error */}
      <AddGuestForm form={form} />
      <MobileFooter
        primaryButton={(
          <Button
            variant={ButtonVariants.Dark}
            label={t("add")}
            width="100%"
            icon={PlusIcon}
            onClick={() => {
              form.handleSubmit();
            }}
          />
        )}
        secondaryButton={(
          <Button
            variant={ButtonVariants.Light}
            label={t("cancel")}
            width="100%"
            icon={MultiplyIcon}
            onClick={() => {
              hideAddGuestForm();
              resetCurrentSelectedParticipant();
            }}
          />
        )}
      />
    </div>
  );
}
